import { SvelteMap } from "svelte/reactivity";
import { extractSigned, sendBeacon } from "../lib/railsUtil.svelte";

// Used by any component to record interactions (or set data-interaction
// on a clickable element and let Interactions.svelte handle it)

export async function recordInteraction(signedInteraction) {
  let path = await interactionsPath
  const plainInteraction = extractSigned(signedInteraction);
  addEvent(plainInteraction);
  sendBeacon(path, {interaction: signedInteraction})
}

// Used by any component to read existing & live interactions

export interface Interaction {
  name: string;
  at: number; // seconds, not milliseconds
}

class EventsStore {
  #ready : Promise<EventsStore>
  #resolveReady : (store : EventsStore)=>void
  #events = $state(new SvelteMap<string, Interaction>());
  initialized = $state(false);

  constructor(){
    this.#ready = new Promise((resolve, _)=>this.#resolveReady = resolve)
  }

  addEvent(event : Interaction) {
    const existing = this.#events.get(event.name)
    this.#events.set(event.name, (existing && existing.at > event.at) ? existing : event)
  }

  get(name : string) { return this.#events.get(name) }

  getEvents(...names : string[]) { return names.flatMap(name => this.get(name) || []) }

  get ready(){ return this.#ready }

  markInitialized() {
    this.initialized = true
    this.#resolveReady(this)
  }
}
export let interactions = $state(new EventsStore());
export const interactionsReady = () => interactions.ready

// Used only internally and by Interactions.svelte

const addEvent = (event: {name: string; at?: number}) => interactions.addEvent({...event, at: Date.now() / 1000})

export const setEvents = (events: Interaction[]) => {
  for(const event of events) interactions.addEvent(event);
  interactions.markInitialized()
};

let pathResolver
export function resolveInteractionsPath(path) {
  pathResolver(path)
}
const interactionsPath = new Promise((resolve) => {
  pathResolver = resolve
});
